skrilla.service('withdrawalService', function(cacheService, modalService){

    let bounceWithdrawal = function(withdrawal){
        cacheService.registerObject("bounceWithdrawal", withdrawal);
        modalService.openModal('/views/withdrawals/bounceWithdrawalModal.html',true, 'lg', true, true, function(){
            withdrawal.status = "BOUNCED";
        });
    }

    const blockedByProfileTag = (withdrawal) => {
        const blockedTags = ['COMPLIANCE_REVIEW', 'BET_CHECK_REQUIRED'];
        return withdrawal?.userTags?.some(tag => blockedTags.includes(tag));
    };

    return {
        bounceWithdrawal: bounceWithdrawal,
        blockedByProfileTag: blockedByProfileTag,
    };
});

